import type { AxiosInstance } from 'axios';
import { BaseService } from './BaseService';
import type { BrandViewModel, BrandCreateModel, BrandUpdateModel } from '../types/brand';
import { apiClient } from '../client/client';

/**
 * Brand service – one service per Brand controller.
 * GET supports Name, pagination, orderBy (via BaseService.getAll).
 */
export class BrandService extends BaseService<
  BrandViewModel,
  BrandCreateModel,
  BrandUpdateModel,
  BrandViewModel[]
> {
  private static readonly BASE = '/api/brand';

  constructor(client: AxiosInstance = apiClient) {
    super(client, BrandService.BASE);
  }
}

export const brandService = new BrandService();
